interface SearchInputProps {
  value: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
  placeholder?: string;
  className?: string;
  type: string;
  name?: string;
  title?: string;
}

const SearchInput: React.FC<SearchInputProps> = ({
  value,
  onChange,
  onKeyDown,
  placeholder = "Search",
  className = "",
  type,
  name,
  title,
}) => {
  return (
    <form className="formCol formCol--search" onSubmit={(e) => e.preventDefault()}>
      <input
        className={`form__input form__input--search form__input--sm ${className}`}
        type={type}
        name={name || ""}
        value={value}
        placeholder={placeholder}
        onChange={onChange}
        onKeyDown={onKeyDown}
        title={title}
      />
    </form>
  );
};

export default SearchInput;
